.pane {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
  padding: 20px;
}

.label {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ink-3);
}

.row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 15px;
}

.week {
  font-weight: 600;
}

.counts {
  color: var(--ink-2);
  font-variant-numeric: tabular-nums;
}

.days {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 5px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.day {
  display: flex;
}

/* A day's bar and letter, filling its column. One that opens the Diary
 * (#150) is a 44px target, marked under the pointer and when focused by an
 * outline, never by a colour that would mix with its completeness. */
.cell {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 0;
  min-height: 44px;
  border-radius: 8px;
  color: inherit;
  text-decoration: none;
}

.open:hover {
  outline: 1.5px dashed var(--ink-3);
  outline-offset: 1px;
}

.open:focus-visible {
  outline: 2px solid var(--ink);
  outline-offset: 1px;
}

.bar {
  width: 100%;
  height: 14px;
  border: 1.5px solid var(--ink);
  border-radius: 999px;
  background: var(--surface);
}

.COMPLETE {
  background: var(--done);
}

.PARTIAL {
  background: var(--accent);
}

.future {
  border: 1.5px dashed var(--ink-3);
}

.letter {
  font-size: 11px;
  font-weight: 500;
  color: var(--ink-3);
}

.current {
  font-weight: 700;
  color: var(--ink);
}

/* Read by screen readers, not shown. */
.hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
